import { filter } from 'lodash-es';
import { Parchment } from 'quill/core';

class CodeEmbedTokenAttributor extends Parchment.ClassAttributor {
  constructor(attrName = 'code-embed-token', keyName = 'code-embed-token') {
    super(attrName, keyName, { scope: Parchment.Scope.INLINE });
  }

  canAdd(node: HTMLElement, value: string | string[]): boolean {
    if (Array.isArray(value)) {
      return value.every((item) => this.canAdd(node, item));
    }
    return super.canAdd(node, value);
  }

  add(node: HTMLElement, value: string | string[]): boolean {
    if (!this.canAdd(node, value)) return false;
    this.remove(node);
    const array = Array.isArray(value) ? value : [value];
    array.forEach((token) => {
      node.classList.add(`${this.keyName}-${token}`);
    });
    return true;
  }

  value(node: HTMLElement): string[] | null {
    const prefix = `${this.keyName}-`;
    const list = filter(node.classList, (c) => {
      return c.startsWith(prefix);
    }).map((c) => {
      return c.slice(prefix.length);
    });
    return list.length > 0 ? list : null;
  }
}

export default new CodeEmbedTokenAttributor();
